document.addEventListener('click', function(event) {
    const menuToggle = document.querySelector('.tt-desctop-menu');
    const menu = document.querySelector('.tt-dropdown-menu');

    if (!menu || !menuToggle) {
        return;
    }

    const isClickInsideMenu = menu.contains(event.target);
    const isClickOnToggle = menuToggle.contains(event.target);

    // Check if the menu is currently visible (either by 'active' class or computed style)
    // This is a more robust check than just 'active' class
    const isMenuVisible = menu.classList.contains('active') || (menu.offsetWidth > 0 && menu.offsetHeight > 0);

    // If the menu is visible AND the click is NOT inside the menu AND the click is NOT on the menu toggle itself
    if (isMenuVisible && !isClickInsideMenu && !isClickOnToggle) {
        // Simulate a click on the menu toggle to close the menu using its existing handler
        menuToggle.click();
    }
});